import React from 'react';
import { connect } from 'react-redux';
import { AlTemplateGaitRow } from 'PatientCareCenter/Note/AL/Templates';
import styles from './Common.module.css';


class AlTemplateGait extends React.Component {

    render() {
        if (this.props.activities.length > 0) {
            return (
                <div className={styles.section_wrapper}>
                    <div className={styles.header_row}>Gait (97116)</div>

                    {Object.keys(this.props.activities)
                        .map(key => {
                            const result = this.props.activities[key];
                            return (
                                <AlTemplateGaitRow key={result.XLTMPGANO} id={result.XLTMPGANO} />
                            )
                        })
                    }
                </div>
            );
        } else {
            return (<span />);
        }
    }
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;

    return {
        activities: state.entities.notes.MLTMPGAIT ?
            Object.keys(state.entities.notes.MLTMPGAIT)
                .filter(key => {
                    return (state.entities.notes.MLTMPGAIT[key].NoteId === noteId)
                })
                .sort((a, b) => state.entities.notes.MLTMPGAIT[a].XLTMPGAORDER - state.entities.notes.MLTMPGAIT[b].XLTMPGAORDER)
                .map(key => state.entities.notes.MLTMPGAIT[key]) : [],
    };
}

const connectedAlTemplateGait = connect(mapStateToProps)(AlTemplateGait);
export { connectedAlTemplateGait as AlTemplateGait };

